// // ProtectedRoute.js
// import React from 'react';
import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   const userEmail = localStorage.getItem('userEmail');

//   if (!userEmail) {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;
const ProtectedRoute = ({ children }) => {
  const userEmail = localStorage.getItem('userEmail');
  const tokenExpiry = localStorage.getItem('tokenExpiry'); // optional expiry timestamp

  const isExpired = tokenExpiry && new Date().getTime() > parseInt(tokenExpiry);

  if (!userEmail || isExpired) {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('tokenExpiry');
    return <Navigate to="/" replace />;
  }

  return children;
};
export default ProtectedRoute;